/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'

const Wrapper = styled.div`
  padding: 16px;
  text-align: center;
`

const Img = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-bottom: 12px;
`

const Caption = styled.p`
  font-size: 14px;
  color: #666;
`

export default function AnnouncementImage({ data }) {
  return (
    <Wrapper>
      <Img src={data.media_url} alt={data.title} />
      {data.text_content && <Caption>{data.text_content}</Caption>}
    </Wrapper>
  )
}
